import { Autocomplete, TextField, TextFieldVariants } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  ListRequestOfBaseFilter,
  ProductVersion,
} from "services/KnowfullyAdminClient";

type SelectProductVersionMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectProductVersionMultiple = ({
  onChange,
  value,
  variant,
  disabled,
}: SelectProductVersionMultipleProps) => {
  const { productService } = useGlobalContext();
  const { formatMessage: t } = useIntl();

  const { data, isFetching } = useQuery(
    ["productVersions"],
    () =>
      productService.getProductVersions(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  const handleChangeMultiple = (_: any, values: ProductVersion[]) => {
    onChange(values.map((v) => v.id!));
  };

  const versions = data?.data ?? [];

  return (
    <Autocomplete
      multiple
      ChipProps={{ size: "small" }}
      options={versions}
      getOptionLabel={(option) => option.name ?? "?"}
      value={versions.filter((r) => value.includes(r.id!) ?? [])}
      onChange={handleChangeMultiple}
      loading={isFetching}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={t({ id: "productVersionLabel" })}
        />
      )}
    />
  );
};

export default SelectProductVersionMultiple;
